import React, { useEffect } from "react";
import HowWeCanHelpBanner from "../../components/DataComponents/HowWeCanHelpBanner/HowWeCanHelpBanner";
import Section from "../../components/Section/Section";
//import Box from "@mui/material/Box";
import { Trans, useTranslation } from "react-i18next";
//import HighlightLink from "components/Hightlight/HighlightLink";
//import { Grid } from "@mui/material";
import { HireUsMdBtn } from "./HowWeCanHelpPage.styled";
import { TitleHighlight } from "components/Section/Section.styled";
import useDevice from "hooks/useDevice";
import Commitments from "components/Commitment/Commitments";
import Commitment1 from "assets/images/pages/how-we-can-help/ideas1.jpg";
import Commitment2 from "assets/images/pages/how-we-can-help/ideas2.jpg";
import Commitment3 from "assets/images/pages/how-we-can-help/ideas3.jpg";
import Commitment4 from "assets/images/pages/how-we-can-help/ideas4.jpg";
import Commitment5 from "assets/images/pages/how-we-can-help/ideas5.jpg";
import CommitmentIcon1 from "../../static/commitment_icon1.svg";
import CommitmentIcon6 from "../../static/commitment_icon6.png";
import CommitmentIcon4 from "../../static/commitment_icon4.png";
import CommitmentIcon5 from "../../static/commitment_icon5.png";
import { ReactComponent as ButtonIcon } from "assets/images/svg/arrow-up-right-black.svg";
import { BackgroundType } from "../../constants/backgroundType";
import i18next from "i18next";
import Process from "components/DataComponents/Process/Process";
import { PAGES } from "constants/pages";

const breakElement = <br key={0} />;
const HireUsBtn = (
  <HireUsMdBtn
    size={"md"}
    isLink={true}
    marginTop={"0px"}
    maxWidth={"auto"}
    to={PAGES.CONTACT.route}
    smooth={true}
  >
    <Trans i18nKey="howWeCanHelpPage.intro.hireUs" />
    <ButtonIcon></ButtonIcon>
  </HireUsMdBtn>
);

const HowWeCanHelpPage = () => {
  const { isMobile } = useDevice();
  const { t } = useTranslation();
  useEffect(() => {
    document.title = i18next.t("pageTitles.Career");
  }, []);

  const items = [
    {
      title: (
        <Trans
          t={t}
          i18nKey="howWeCanHelpPage.paragraf2.items.item1.header"
          components={[breakElement]}
        />
      ),
      text: i18next.t("howWeCanHelpPage.paragraf2.items.item1.text"),
      image: Commitment1,
      type: BackgroundType.DARK_BLUE,
      reverse: true,
      mobileInverted: true,
      margin: "25px 0px",
      width: isMobile ? "100%" : "75%",
      icon: CommitmentIcon6,
      iconProperties: {
        height: "138px",
        width: "50px",
        right: "-41%",
      },
      button: HireUsBtn,
    },
    {
      title: (
        <Trans
          t={t}
          i18nKey="howWeCanHelpPage.paragraf2.items.item2.header"
          components={[breakElement]}
        />
      ),
      text: i18next.t("howWeCanHelpPage.paragraf2.items.item2.text"),
      image: Commitment2,
      type: BackgroundType.BLUE,
      mobileInverted: true,
      margin: "25px 0px",
      width: isMobile ? "100%" : "75%",
      icon: CommitmentIcon5,
      iconProperties: {
        height: "50px",
        width: "45px",
        left: "-43%",
      },
      button: HireUsBtn,
    },
    {
      title: i18next.t("howWeCanHelpPage.paragraf2.items.item3.header"),
      text: i18next.t("howWeCanHelpPage.paragraf2.items.item3.text"),
      image: Commitment3,
      type: BackgroundType.DARK_BLUE,
      icon: CommitmentIcon6,
      reverse: true,
      mobileInverted: true,
      margin: "25px 0px",
      width: isMobile ? "100%" : "75%",
      iconProperties: {
        height: "45px",
        width: "35px",
        right: "-17%",
      },
      button: HireUsBtn,
    },
    {
      title: (
        <Trans
          t={t}
          i18nKey="howWeCanHelpPage.paragraf2.items.item4.header"
          components={[breakElement]}
        />
      ),
      text: i18next.t("howWeCanHelpPage.paragraf2.items.item4.text"),
      image: Commitment4,
      type: BackgroundType.YELLOW,
      icon: CommitmentIcon4,
      margin: "25px 0px",
      mobileInverted: true,
      width: isMobile ? "100%" : "75%",
      iconProperties: {
        height: "45px",
        width: "35px",
        left: "-29%",
        top: "16%",
      },
      button: HireUsBtn,
    },
    {
      title: (
        <Trans
          t={t}
          i18nKey="howWeCanHelpPage.paragraf2.items.item5.header"
          components={[breakElement]}
        />
      ),
      text: i18next.t("howWeCanHelpPage.paragraf2.items.item5.text"),
      image: Commitment5,
      type: BackgroundType.DARK_BLUE,
      icon: CommitmentIcon1,
      reverse: true,
      mobileInverted: true,
      margin: "25px 0px",
      width: isMobile ? "100%" : "75%",
      iconProperties: {
        height: "45px",
        width: "35px",
        left: "-29%",
        top: "16%",
      },
      button: HireUsBtn,
    },
  ];

  return (
    <>
      <Section bgColor="white">
        <HowWeCanHelpBanner />
      </Section>
      <Section
        bgColor="dark"
        titleAlignLeft={false}
        cardTitle={
          <Trans
            t={t}
            components={[<TitleHighlight fontWeight="extraBold" isStyled={true} key={0} />]}
            i18nKey="howWeCanHelpPage.paragraf1.header"
          />
        }
        margin={isMobile ? "64px 0px 32px" : "120px 0 80px"}
        paddingBottom={isMobile ? "10px" : "20px"}
      >
        <Process />
      </Section>
      <Section
        isStyled={true}
        bgColor="white"
        titleAlignLeft
        cardTitle={
          <Trans
            t={t}
            components={[<TitleHighlight fontWeight="extraBold" isStyled={true} key={0} />]}
            i18nKey="howWeCanHelpPage.paragraf2.header"
          />
        }
        margin={isMobile ? "32px 0px" : "120px 0px 37px"}
        paddingBottom={isMobile ? "10px" : "20px"}
        lineHeight={isMobile ? "125%" : "100%"}
      >
        <Commitments items={items} container />
      </Section>
    </>
  );
};

export default HowWeCanHelpPage;
